import { gql } from "@apollo/client";

export const GET_ALL_SUBUSERS = gql`
  query GetAllSubusers {
    getAllSubusers {
      id
      name
      lastname
    }
  }
`;

export const GETSALES = gql`
  query getSales($branch_id: Int, $startDate: String, $endDate: String) {
    getSales(branch_id: $branch_id, startDate: $startDate, endDate: $endDate) {
      posSales {
        count
        total
      }
      onlineSales {
        count
        total
      }
      fees
      orders {
        id
        type
        total
        creation
        creation_date
        delivery
        cash_income
        resume_txt
        delivery_type
        payment_type
        tip
        status
        payed
        user {
          id
          name
          lastname
        }
        table {
          id
          name
        }
        products {
          id
          qty
          price
          ingredients
          ingredients_txt
          ingredients_opt
          size
          product {
            id
            title
            model
          }
        }
      }
    }
  }
`;

export const GET_SALES_DASHBOARD = gql`
  query getSalesDashboard(
    $branch_id: Int
    $startDate: String
    $endDate: String
  ) {
    getSalesDashboard(
      branch_id: $branch_id
      startDate: $startDate
      endDate: $endDate
    ) {
      totalRevenue
      totalOrders
      avgTicket
      totalTips
      totalDeliveryFees
      cancelledOrders
      posSales {
        count
        total
      }
      onlineSales {
        count
        total
      }
      byDeliveryType {
        type
        count
        total
      }
      byPaymentType {
        type
        count
        total
      }
      hourlyBreakdown {
        hour
        count
        total
      }
      dailyBreakdown {
        date
        count
        total
      }
      topProducts {
        productId
        title
        model
        quantity
        total
      }
      salesByPerson {
        userId
        name
        lastname
        count
        total
      }
    }
  }
`;
